(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["av-privacy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-cookie-controls')) {
 customElements.define('av-cookie-controls', class extends HTMLElement {
  connectedCallback() { this.dialog=this.querySelector('dialog');this.status=this.querySelector('[data-status]');this.listener=this.click.bind(this);document.addEventListener('click',this.listener); }
  disconnectedCallback(){document.removeEventListener('click',this.listener);}
  async api(){
   if(window.Shopify?.customerPrivacy)return window.Shopify.customerPrivacy;
   if(!window.Shopify?.loadFeatures)throw new Error('Unavailable');
   await new Promise((resolve,reject)=>{const timer=setTimeout(()=>reject(new Error('Timeout')),10000);window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{clearTimeout(timer);error?reject(error):resolve();});});
   if(!window.Shopify.customerPrivacy)throw new Error('Unavailable');return window.Shopify.customerPrivacy;
  }
  sync(api){const consent=api.currentVisitorConsent();this.querySelectorAll('input').forEach(input=>{input.checked=consent[input.name]==='yes';input.disabled=false;});this.querySelectorAll('[data-action]').forEach(button=>button.disabled=false);}
  async open(){
   if(window.privacyBanner?.showPreferences){try{await window.privacyBanner.showPreferences();return;}catch{}}
   this.status.textContent='';this.dialog.showModal();try{this.sync(await this.api());}catch{this.status.textContent=this.dataset.error;}
  }
  async click(event){
   if(event.target.closest('[data-av-cookies]')){event.preventDefault();await this.open();return;}
   if(!this.contains(event.target))return;
   if(event.target.closest('[data-close]')){this.dialog.close();return;}
   const button=event.target.closest('[data-action]');if(!button)return;
   button.disabled=true;this.status.textContent='';
   try{
    const api=await this.api(),action=button.dataset.action;
    const consent=Object.fromEntries(['preferences','analytics','marketing'].map(key=>[key,action==='accept'?true:action==='decline'?false:this.querySelector('input[name="'+key+'"]').checked]));
    await new Promise((resolve,reject)=>{const timer=setTimeout(()=>reject(new Error('Timeout')),10000);api.setTrackingConsent(consent,result=>{clearTimeout(timer);result?.error?reject(new Error(result.error)):resolve();});});
    const saved=api.currentVisitorConsent();if(!Object.entries(consent).every(([key,value])=>saved[key]===(value?'yes':'no')))throw new Error('Not saved');
    this.sync(api);this.status.textContent=this.dataset.saved;
   }catch{this.status.textContent=this.dataset.error;}finally{button.disabled=false;}
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
